// Form validation for Task form
import { plaintextValidator, userValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  technician: userValidator(config),
  groupId: plaintextValidator(config),
  technicianId: plaintextValidator(config)
};
